<template>
  <div>
    <b-loading :is-full-page="false" v-model="isLoading"></b-loading>
    <div class="columns px-4">
      <div class="column has-text-left pl-0">
        <router-link to="/tournaments">
          <a class="is-size-5 has-text-link">
            &lt;&lt; Tournaments
          </a>
        </router-link>
      </div>

      <div class="column">
        <h1 class="title has-text-success">
          🏆 Hall of Fame 🏆
        </h1>
      </div>

      <div class="column"></div>
    </div>

    <div class="px-4">
      <div
        v-for="(item, i) in playerRewards"
        :key="item.player.username"
        class="columns is-vcentered"
        :class="i % 2 ? 'odd' : 'even'"
      >
        <span class="column is-1 p-1">{{ i + 1 }}</span>
        <span class="column p-1">
          <ProfileCard :player="item.player.user" />
        </span>
        <span class="column p-1">
          <PlayerTrophies :rewards="item.rewards" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileCard from "@/components/players/ProfileCard.vue";
import PlayerTrophies from "@/components/stats/PlayerTrophies.vue";
import { firestore } from "@/services/firebase";
import { TOURNAMENT_TROPHIES } from "../constants";
import { getRewardPoints } from "vue-chess-shared/tournament/helper";

export default {
  components: { ProfileCard, PlayerTrophies },
  name: "HallOfFame",

  data() {
    return {
      rewards: null,
      isLoading: true,
      includedRewards: TOURNAMENT_TROPHIES,
    };
  },

  computed: {
    playerRewards() {
      if (!this.rewards) return [];
      const playerRewards = {};
      this.rewards.forEach((item, i) => {
        if (!item.player || !item.player.username) {
          console.log(i, item);
          return;
        }
        const key = item.player.username;
        if (!playerRewards[key]) playerRewards[key] = { rewards: [] };
        playerRewards[key].rewards = [...playerRewards[key].rewards, item];
      });
      return Object.values(playerRewards)
        .map((item) => ({
          player: item.rewards[0].player,
          rewards: item.rewards,
          rewardPoints: item.rewards.reduce(
            (r, item) => r + getRewardPoints(item.reward),
            0
          ),
        }))
        .sort((a, b) => b.rewardPoints - a.rewardPoints);
    },
  },

  created() {
    firestore
      .collectionGroup("rewards")
      .where("reward", "in", TOURNAMENT_TROPHIES)
      .get()
      .then((querySnapshot) => {
        this.rewards = querySnapshot.docs.map((doc) => doc.data());
        this.isLoading = false;
      });
  },
};
</script>

<style scoped>
.odd {
  background-color: #c3eeee;
}

.even {
  background-color: lightcyan;
}
</style>
